window.addEventListener('DOMContentLoaded', function() {
    ( function( $ ) {

        $(".video_item").modalVideo({
            channel:'vimeo'
        });
        
        $(".video_one_item").modalVideo({
            channel:'vimeo'
        });

        $('.scrollToJobs').click(function(e){
            $([document.documentElement, document.body]).animate({
                scrollTop: $(".jobsContainer").offset().top - 50
            }, 1200);
        });
    
        // Check there isn't a gated case study quote carousel as we don't want to slick that.
        if( $('.gatedCaseStudies').length == 0){

            $('.textCarouselRight').slick({
                dots: true,
                infinite: true,
                arrows: true,
                speed: 1000,
                autoplaySpeed: 5000,
                autoplay: false,
                slidesToShow: 1,
                centerMode: false,
                appendDots:  $('.carouselControlsHolderRight .dots'),
                prevArrow: '<div class="prevAnimate"><span></span><span></span></div>',
                nextArrow: '<div class="nextAnimate"><span></span><span></span></div>'
            });

        }

        $('.std-carousel').slick({
            dots: true,
            autoplay: false,
            autoplaySpeed: 5000,
            infinite: false,
            slidesToShow: 2.5,
            fade: false,
            cssEase: 'ease-in-out',
            speed: 1000,
            slide: '.altCarouselItem',
            variableWidth: true,
            //prevArrow: '<div class="prevAnimate"><span></span><span></span></div>', //comment this out as we are only showing one arrow
            nextArrow: '<div class="prevAnimate"><span></span><span></span></div>', //<div class="nextAnimate"><span></span><span></span></div> - fake this prevAnimate arrow as the next arrow!
            responsive: [{
                breakpoint: 767, // mobile breakpoint
                settings: {
                    slidesToShow: 2.5,
                    nextArrow: '<div class="prevAnimate"><span></span><span></span></div>'
                }
            },
            {
                breakpoint: 650, // mobile breakpoint
                settings: {
                    slidesToShow: 1.2,
                    nextArrow: '<div class="prevAnimate"><span></span><span></span></div>'
                }
            }]
        });

        repositionCarouselDescription();

        // Check if there is a 'continuous' carousel on the page before triggering the functional setup.
        if( $( '.continous' ).length > 0){

            var $c = $('.continous'),
                $k = $('.continous2'),
                $w = $(window);

            $c.carouFredSel({
                align: false,
                items: 10,
                scroll: {
                    items: 1,
                    duration: 2000,
                    timeoutDuration: 0,
                    easing: 'linear',
                    pauseOnHover: 'immediate'
                }
            });

            $k.carouFredSel({
                align: false,
                items: 10,
                direction : "right", 
                scroll: {
                    items: 1,
                    duration: 2000,
                    timeoutDuration: 0,
                    easing: 'linear',
                    pauseOnHover: 'immediate'
                }
            });

            $w.bind('resize.example', function() {
                var nw = $w.width();
                if (nw < 990) {
                    nw = 990;
                }

                $c.width(nw * 3);
                $c.parent().width(nw);

                $k.width(nw * 3);
                $k.parent().width(nw);

            }).trigger('resize.example');

        }

        $(window).on("resize", function() {

            if( $( window ).width() < 768 ){
                setTimeout(function(){repositionCarouselDescription();}, 450);
            }

        });

        function repositionCarouselDescription(){

            $(".description").insertBefore($(".slick-dots"));

        }

        // Hoshi Form Styles
        $('.input__field').change(function () {
            var $this = $(this);
            var $thisInput = $this.find('input');
            if ($this.val() !== "") {
                $this.addClass('input--filled');
            } else {
                $this.removeClass('input--filled');
            }
        });

        // We need to move the 'label' that CF7 generates into the main span wrapper so that the 'hoshi' styling works!
        var spans = document.getElementsByClassName("wpcf7-form-control-wrap");

        for( var i=0 ; i < spans.length ; i++ ) {

            var input = spans[i].nextSibling;

            if( input != null ){

                if( input.tagName == "LABEL" ){

                    spans[i].appendChild( input );

                }

            }

        }

        // Job vacancies functions.
        $('body').on('click', '.sayHello', function () {
            $('.formOuter').addClass('active');
        });

        $('body').on('click', '.viewJobs', function () {
            $('.join').addClass('active');
        });

        $('body').on('click', '.checkBoxHolder', function () {
                        
            $(this).toggleClass('active');

            var checkBox = $(this).closest('.customCheckBox').find('.wpcf7-list-item label input[type=checkbox]');

            isChecked = checkBox.is(':checked');
                        
            if (isChecked) {
                checkBox.attr("checked", false);
            } else {
                checkBox.attr('checked', true);
            }

        });
        
        // Check for any click on the custom checkbox label.
        $('.customCheckBox label').on("click", function( evt ){                                           
                                    
            if( evt.target.tagName === "INPUT"){
                            
                if( $( ".checkBoxHolder" ).length > 0 ){

                    $( ".checkBoxHolder" ).toggleClass('active');

                }
                
            }
            
        });
        
        $(document).mouseup(function (e) {
            var container = $(".formOuter.active, .join.active");
            // if the target of the click isn't the container nor a descendant of the container
            if (!container.is(e.target) && container.has(e.target).length === 0) {
                container.removeClass('active');
            }
        });

        $('body').on('click', '.formOuter .closeButton, .join .closeButton', function () {
            $(this).closest('.closeThis').removeClass('active');
        });

        if(getUrlParameter('open') == 'form'){

            setTimeout(function(){
                $('.sayHello').trigger('click');
            }, 1800);

        } else if(getUrlParameter('open') == 'jobs'){

            setTimeout(function(){

                $('.viewJobs').trigger('click');

                var scrollId = $('.scrollToPart').attr('id');

                if(scrollId){

                    $('.'+scrollId).children('section.job h3').trigger('click');
                    $('html,body').animate({
                        scrollTop: $('.'+scrollId).offset().top - 70
                    }, 'slow');

                }

            }, 1800);
        }

        $('body').on('click', '.showForm', function(){
            $(this).closest('.expandThis').find('.formContainer').slideToggle();
        });

        $('body').on('click', 'section.job h3', function (e) {

            e.preventDefault();
            var el = $(this);

            $('.job').each(function(){
                var button = $(this).find('h3')
                if(e.target != button[0]){
                    button.closest('.job').find('.plusMinus').removeClass('active');
                    $(this).find('.expandThis').stop().slideUp(400, function () {});
                }
            });

            var expandable = el.closest('.job').find('.expandThis');
            var plusMinus = el.closest('.job').find('.plusMinus');

            if (expandable.length) {
                plusMinus.toggleClass('active');
                togglejobs(expandable);
            }

        });

        $( 'body' ).on( 'click', '.wpcf7-form-control.wpcf7-submit', function(){

           // Attempt to figure out which job form is being submitted.
           var jobForm = $( this ).closest('section').attr('id');

           // Set the hidden input type with the job form section id.
           $( '#jobFormActive' ).val( jobForm );

        });
        
        function msieversion() {
            var ua = window.navigator.userAgent;
            var msie = ua.indexOf("MSIE 10");

            if (msie > 0){
                $("[data-aos^=fade][data-aos^=fade]").css("opacity", "1");        
            }else{
                AOS.init();
            }

        }
        
        $(document).ready(function () {        

            msieversion();
        
        });
        
        /**
         * WINDOW ON RESIZE
         */
        $( window ).on('resize', function(){

            AOS.refresh();           

        });

        /**
         * WINDOW ON LOAD
         */
        $( window ).on('load', function() {

            setTimeout(AOS.refreshHard, 150);            

        });

    } )( jQuery );
});

function emailCurrentPage(){
    
    window.location.href="mailto:?subject="+document.title+"&body="+escape(window.location.href);
    
}

function tweetCurrentPage(){

    window.open(
        "https://twitter.com/share?text="+document.title+"&url="+escape(window.location.href),
        '_blank'
    );
    
}

// Add listener for the Contact Form 7 plugin that check if the form has been submitted, if so hide it completely.
document.addEventListener('wpcf7mailsent', function( event ) {
    
    if( jQuery( '#asaphide' ).length > 0 ){
        document.getElementById('asaphide').style.display = 'none';
    }
    
    // Deal with multiple forms on the same page by determining which form has been submitted - mainly for the 'Join' section.
    if( jQuery( '#jobFormActive' ).length > 0 ){
        
        var formToClose = jQuery( '#jobFormActive' ).val();
                
        jQuery( '#' + formToClose + ' .hideVacancyOnSubmit').addClass('none');
        
    }
    
}, false );